import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import {
  CustomLightThemeProvider,
  CustomDarkThemeProvider,
} from './CustomThemeProvider';

const lightThemeExtension = ThemeBlueprint.make({
  name: 'light',
  params: {
    theme: {
      id: 'light',
      title: 'Light',
      variant: 'light',
      Provider: CustomLightThemeProvider,
    },
  },
});

const darkThemeExtension = ThemeBlueprint.make({
  name: 'dark',
  params: {
    theme: {
      id: 'dark',
      title: 'Dark',
      variant: 'dark',
      Provider: CustomDarkThemeProvider,
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [lightThemeExtension, darkThemeExtension],
});
